import axios from '@/libs/axios';
import { useQuery } from '@tanstack/react-query';
import { Urls } from '../constant';
//
export const userBalance = data => {
  return axios.post(Urls.balanceUrl, {
    user_id: data.id
  });
};
export const useBalance = ({
  id,
  config
}) => {
  return useQuery({ ...config,
    queryKey: ['user-assets', id],
    queryFn: () => userBalance({
      id
    })
  });
};